diy.angular.registerFactory('diyfilevalidator', ['$q', 'diyl10n', 'diyfilename', 'diyimageresize', function($q, diyl10n, diyfilename, diyimageresize) {
    var roundTo = function(num) {
        return Math.round(num * 100) / 100;
    };

    var REQUEST_ENTITY_TOO_LARGE = 413,
        UNSUPPORTED_MEDIA_TYPE = 415,
        UNPROCESSABLE_ENTITY = 422,
        FILE_EMPTY = 469;

    return {
        getMessageByHttpErrorCode: function(httpErrorCode) {
            var mapping = {};
            mapping[REQUEST_ENTITY_TOO_LARGE] = diyl10n('diyfilevalidator.maxSize');
            mapping[UNSUPPORTED_MEDIA_TYPE] = diyl10n('diyfilevalidator.type');
            mapping[UNPROCESSABLE_ENTITY] = diyl10n('diyfilevalidator.corrupt');
            mapping[FILE_EMPTY] = diyl10n('diyfilevalidator.fileEmpty');
            return mapping[httpErrorCode];
        },
        // not yet used
        validateDimension: function(file, validationRules) {
            var deferred = $q.defer();

            if ('maxWidth' in validationRules && 'maxHeight' in validationRules) {
                diyimageresize.getImageByFile(file).then(function(img) {
                    var w = img.naturalWidth;
                    var h = img.naturalHeight;

                    if (
                        ('maxWidth' in validationRules && validationRules['maxWidth'] < w)
                            || ('maxHeight' in validationRules && validationRules['maxHeight'] < h)
                        ) {
                        deferred.reject({file: file, message: diyl10n('diyfilevalidator.maxDimensions').format({
                            width: w,
                            height: h,
                            maxWidth: validationRules['maxWidth'],
                            maxHeight: validationRules['maxHeight']
                        })});
                    } else {
                        deferred.resolve(file);
                    }
                }, function(errors) {
                    deferred.reject({file: file, message: diyl10n('diyfilevalidator.corrupt')});
                });
            } else {
                // if no dimension check is needed and we reached here, it's ok
                deferred.resolve(file);
            }

            return deferred.promise;
        },
        validate: function(file, validationRules) {
            // general validation, prevent empty files
            if (file.size === 0) {
                return {file: file, error: {code: FILE_EMPTY, message: this.getMessageByHttpErrorCode(FILE_EMPTY)}};
            }
            
            if ('maxSize' in validationRules) {
                if (validationRules['maxSize'] < file.size) {
                    return {file: file, error: {code: REQUEST_ENTITY_TOO_LARGE, message: this.getMessageByHttpErrorCode(REQUEST_ENTITY_TOO_LARGE).format({
                        size: roundTo(file.size / (1024 * 1024)),
                        maxSize: roundTo(validationRules['maxSize']  / (1024 * 1024))
                    })}};
                }
            }
            if ('type' in validationRules) {
                var fileObj = diyfilename.parse(file.name);
                if (validationRules['type'].indexOf(fileObj.extension.toLowerCase()) === -1) {
                    return {file: file, error: {code: UNSUPPORTED_MEDIA_TYPE, message: this.getMessageByHttpErrorCode(UNSUPPORTED_MEDIA_TYPE).format({
                        allowedTypes: validationRules['type'].join(", ")
                    })}};
                }
            }
            return true;
        }
    };
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/angular/services/diyfilevalidator.js
 ** module id = 935
 ** module chunks = 0
 **/